import React, { SVGProps } from 'react'
const SvgFilledAlert = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="#D5404A"
      fillRule="evenodd"
      d="M8 1.5a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13Z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      d="M7.932 4.173a.5.5 0 0 1 .495.426l.005.074v4.783a.5.5 0 0 1-.994.074l-.006-.074V4.673a.5.5 0 0 1 .5-.5ZM7.915 10.835a.5.5 0 0 1 .494.426l.006.074v.282a.5.5 0 0 1-.995.074l-.005-.074v-.282a.5.5 0 0 1 .5-.5Z"
    />
  </svg>
)
export default SvgFilledAlert
